import React from 'react'
import "./Task_income_cards.css"
import { faAddressBook } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

function Task_income_cards() {
    return (
        <>
            <section className='Task_income_cards'>
                <div className="card_headers_holder">
                    <div className="row">
                        <div className="col-6">
                            <div className="heading_text">
                                <h5> <FontAwesomeIcon icon={faAddressBook} className='me-2' /> Sr. No. 01</h5>
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="heading_text">
                                <h5 className='status_text'>Success</h5>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="data_text_holder">
                    <div className="row">
                        <div className="col-6">
                            <div className="text_holder">
                                <p>Amount:</p>
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="text_holder">
                                <p className='right_text'>6000</p>
                            </div>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-6">
                            <div className="text_holder">
                                <p>Date:</p>
                            </div>
                        </div>

                        <div className="col-6">
                            <div className="text_holder">
                                <p className='right_text'>12 JAN 25 | 2:30</p>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Task_income_cards